'use strict'

# Groupon.setWindowLocation:
module.exports = Groupon.setWindowLocation = (href) ->
  window.location.href = href
  if href.indexOf('#') > -1
    location.reload()
  return # Necessary !! Prevent mobile browsers to open app dialog modal



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_setWindowLocation.coffee